export const RESET_SEARCH = 'RESET_SEARCH';
export const SET_DESCRIPTION = 'SET_DESCRIPTION';
export const SET_PRODUCTS = 'SET_PRODUCTS';
export const APPEND_PRODUCTS = 'APPEND_PRODUCTS';
export const PREPEND_PRODUCTS = 'PREPEND_PRODUCTS';